import ax from '../axios';
import { API_URL } from "../index";

const AVATAR_URL = API_URL.CONTENT_MODULE + "/avatar";

const getAvatars = (query:any) => {
  return ax.get(`${AVATAR_URL}?${query}`);
}

export {
  getAvatars,
}
